import { FC } from "react";
import { Room } from "../../app/types/RoomsTypes";
import PersonIcon from "@mui/icons-material/Person";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { getFontClass } from "../../helpers/fontUtils";
import Button from "../../components/atoms/Button";

interface RoomCardProps {
  room: Room;
  link: string;
  buttonLink?: string;
}

const RoomCard: FC<RoomCardProps> = ({ room, link, buttonLink }) => {
  const { locale, generalSettings } = useSelector(
    (state: RootState) => state.generalSettings,
  );

  return (
    <Link to={link} className="cursor-pointer block w-full">
      <div className="flex items-center justify-between flex-nowrap w-full">
        <span
          style={{ fontWeight: 600, fontSize: 18 }}
          title={room.name[locale]}
          className={`block py-2 overflow-hidden text-ellipsis whitespace-nowrap lg:max-w-[45%] max-w-[30%] ${getFontClass(generalSettings.events_styling.font_family)}`}
        >
          {room.name[locale]}
        </span>
        <div
          className={`flex justify-center items-center gap-1 pr-2 text-[16px] lg:text-[20px] whitespace-nowrap ${getFontClass(generalSettings.events_styling.font_family)}`}
        >
          <PersonIcon
            className={`text-[${generalSettings.booking_styling.textColor}] w-24 h-24`}
          />
          {room.min_capacity} - {room.max_capacity}
        </div>
      </div>
      <div className="relative ">
        {room.images.length === 0 ? (
          <div className="flex items-center justify-center w-96 h-48">
            <ImageNotSupportedIcon
              style={{
                width: "100%",
                height: "100%",
                color: generalSettings.booking_styling.textColor || "#fff",
              }}
              className="object-cover w-full h-full pb-10"
            />
          </div>
        ) : (
          <img
            src={room.images[0].url}
            alt="room logo"
            className="object-cover h-48 w-full sm:w-full"
          />
        )}
        {generalSettings.events_styling.room_card_button_show === 1 && (
          <div
            className={`absolute bottom-1 flex justify-end right-1 text-[${generalSettings.booking_styling.textColor}] text-xl w-full ${getFontClass(generalSettings.events_styling.font_family)}`}
          >
            <Link
              className={`z-10 radius-0 bg-color-[#28a745] font-white ${getFontClass(generalSettings.events_styling.font_family)}`}
              to={buttonLink || link}
            >
              <Button
                className={`px-2 py-2 text-lg ${getFontClass(generalSettings.events_styling.font_family)}`}
              >
                {generalSettings.events_text.room_card_button_text[locale]}
              </Button>
            </Link>
          </div>
        )}
      </div>
    </Link>
  );
};

export default RoomCard;
